import { NavLink } from "react-router-dom";
import { navLinkClasses } from "./navClasses";

const NavItem = ({ to, children }) => (
    <li className="nav-item">
        <NavLink className={navLinkClasses} to={to}>{children}</NavLink>
    </li>
)

export default NavItem;
